import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useCurrentUserContext } from 'utils/User';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import useSentinelTeam from 'hooks/useSentinelTeam';

export default function SuperUserRoute({ children }) {
  const { isSuperUser } = useCurrentUserContext();
  const { hasSentinelTeam } = useSentinelTeam();
  const { teamKey } = useParams();
  const location = useLocation();

  // Allow access when the URL has no team prefix (e.g. navigated via
  // "Back to All Teams"), even if a sentinel team is still set on the API.
  const isOutsideTeamScope = !teamKey;

  const shouldRedirect = useMemo(
    () =>
      !isSuperUser || (isSuperUser && hasSentinelTeam && !isOutsideTeamScope),
    [isSuperUser, hasSentinelTeam, isOutsideTeamScope],
  );

  if (shouldRedirect) {
    return (
      <Navigate
        to={ROUTE_NAMES.access_denied}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}

SuperUserRoute.propTypes = {
  children: PropTypes.node,
};

SuperUserRoute.defaultProps = {
  children: null,
};
